import type { ObjectMetadata } from '@olytic/foundation';

import { formatNumber } from '../../objects/format';
import { OBJECT_DEFS } from '../../objects/objectDefs';
import { asCheck, asDateTime, asLabel, column, createdByField, field, lastModifiedByField, lookup, type Row, related, show, text } from './kit';

const def = OBJECT_DEFS['billing-treatments'];
const share = show((v) => `${formatNumber(v)}%`);

/** One way to bill under a policy. Rationale: billing-treatments.md. */
export const billingTreatments: ObjectMetadata<Row> = {
  key: def.key,
  singular: 'Billing treatment',
  plural: def.label,
  icon: def.icon,
  listColumns: def.columns,
  details: [
    field('name', 'Name'),
    field('billing_policy_name', 'Billing Policy', { link: lookup('billing-policies', 'billing_policy_id') }),
    field('method', 'Method', { format: asLabel }),
    field('billing_timing', 'Timing', { format: asLabel }),
    field('billing_frequency', 'Frequency', { format: asLabel }),
    field('is_default', 'Default', { format: asCheck }),
    field('active', 'Active', { format: asCheck }),
    field('item_total', 'Items Total', { format: share }),
    field('sort_order', 'Order', { format: show((v) => formatNumber(v)) }),
    field('created_at', 'Created', { format: asDateTime }),
    field('updated_at', 'Last Modified', { format: asDateTime }),
    createdByField(),
    lastModifiedByField(),
  ],
  sections: [
    { key: 'identity', fields: ['name', 'billing_policy_name', 'method', 'billing_timing', 'billing_frequency', 'is_default', 'active', 'item_total'] },
    { key: 'system', label: 'System', collapsed: true, fields: ['sort_order', 'created_at', 'created_by_name', 'updated_at', 'last_modified_by_name'] },
  ],
  related: [
    related('items', 'Items', 'billing-treatment-items', [
      column('name', 'Item', { primary: true }),
      column('percent', 'Percent', { format: share, align: 'right' }),
      column('trigger', 'Billed', { format: asLabel }),
      column('month_offset', 'Months After Kickoff', { format: show((v) => formatNumber(v)), align: 'right' }),
    ]),
  ],
  titleOf: (row) => text(row.name),
  searchKeys: ['name', 'billing_policy_name'],
};
